import Vue from 'vue'
import Buefy from 'buefy'
import RequestReset from './App.vue'

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(RequestReset)

if(document.getElementById("requestPasswordResetApp")){
    new Vue({
        render:h=>h(
            RequestReset,{
                props:{
                    logo:document.getElementById("requestPasswordResetApp")
                        .getAttribute("logo"),
                    resetUrl:document.getElementById("requestPasswordResetApp")
                        .getAttribute("reset-url")
                }
            }
        )
    }).$mount("#requestPasswordResetApp")
}